import 'whatwg-fetch';
import {
    setIndexBrothersMember,
    setSHOWBrothersMember,
    indexBorthersMember,
    add_msg
} from '../../actions'
import fetchConfig from '../fetchConfig'
import SystemModal from '../SystemModal/SystemModal'
import fetchExtend from '../fetchExtend'
import {history} from "../../router/history";


export default {
    index: (dispatch) => {
        SystemModal.showLoadMsg(dispatch);
        fetch(API_SERVER + '/api/v1/brothers_members', {
            credentials: 'same-origin',
            method: 'GET',
            headers: new fetchConfig().fetchConfigHeaders()
        }).then(fetchExtend.checkStatus)
            .then(fetchExtend.parseJSON)
            .then((json) => {
                SystemModal.closeMsg(dispatch);
                dispatch(setIndexBrothersMember(json))
                // dispatch(hideSpinner());
            })
            .catch(function (error) {
                SystemModal.showLoadErrorMsg(dispatch)
            });
    },

    new: (dispatch) => {
        fetch(API_SERVER + '/api/v1/brothers_members/new', {
            credentials: 'same-origin',
            method: 'GET',
            headers: new fetchConfig().fetchConfigHeaders()
        }).then(fetchExtend.checkStatus)
            .then(fetchExtend.parseJSON)
            .then((json) => {
                    dispatch(setSHOWBrothersMember(json))
                }
            )
            .catch(function (error) {
            });
    },
    create: (dispatch, payload) => {
        SystemModal.showSaveMsg(dispatch);
        let payloadValue = payload.toJS();
        console.log(JSON.stringify(payloadValue))
        let formData = new FormData();
        for (var key in payloadValue){
            formData.append("brothers_member[" + key + "]", payloadValue[key]);
        }

        fetch(API_SERVER + '/api/v1/brothers_members', {
            credentials: 'same-origin',
            method: 'POST',
            headers: new fetchConfig().fetchConfigHeaders(),
            body: formData
        }).then(fetchExtend.checkStatus)
            .then(fetchExtend.parseJSON)
            .then(() => {
                // SystemModal.closeMsg(dispatch);
                add_msg('儲存完成');
                // indexBorthersMember(dispatch);
                dispatch(indexBorthersMember)

            })
            .catch(function (error) {
                SystemModal.showSaveErrorMsg(dispatch)
            });
    },

    destroy: (dispatch, payload) => {
        console.log(payload)
        SystemModal.showDestroyMsg(dispatch);
        fetch(API_SERVER + '/api/v1/brothers_members/' + payload, {
            credentials: 'same-origin',
            method: 'DELETE',
            headers: new fetchConfig().fetchConfigHeaders()
        }).then(fetchExtend.checkStatus)
            .then(fetchExtend.parseJSON)
            .then(() => {
                // SystemModal.closeMsg(dispatch);
                dispatch(indexBorthersMember)
                // indexBorthersMember(dispatch);
                // history.push('/application_for_admission')

            })
            .catch(function (error) {
                SystemModal.showDestroyErrorMsg(dispatch);
            });
    },
}



// WEBPACK FOOTER //
// ./src/dashboards_redux/utils/BrothersMember/BrothersMember.jsx